<ng-container *ngIf="reward; else noReward">
  <div class="preview-title">Customer app preview</div>

  <div class="preview-scroll">
    <section class="preview-section">
      <div class="section-label">Explore panel</div>
      <div class="snack-card-slide" [ngStyle]="getSnackCardStyles()">
        <div class="snack-card-inner" [ngStyle]="getSnackCardInnerStyles()">
          <div class="snack-card-title">{{ getBannerTitle() }}</div>
          <div
            class="snack-card-subtitle"
            *ngIf="reward.bannerSubtitleHtml"
            [innerHTML]="getBannerSubtitleHtml()">
          </div>
          <button
            mat-raised-button
            type="button"
            class="snack-card-button"
            *ngFor="let title of reward.bannerButtonTitles || []">
            {{ title }}
          </button>
        </div>
      </div>
    </section>

    <section class="preview-section">
      <div class="section-label">Reward detail</div>
      <div class="detail-shell">
        <div class="detail-topbar">
          <mat-icon>arrow_back</mat-icon>
          <span>Reward Detail</span>
        </div>

        <div class="detail-content" [ngStyle]="{ color: reward.textColor || '#000000' }">
          <div
            class="detail-header-html"
            *ngIf="reward.detailHeaderHtml"
            [innerHTML]="getDetailHeaderHtml()">
          </div>

          <div
            class="detail-body-html"
            *ngIf="reward.detailContentsHtml"
            [innerHTML]="getDetailContentsHtml()">
          </div>

          <div class="empty-preview" *ngIf="!hasDetailPreview()">
            No reward detail content is configured.
          </div>
        </div>

        <div class="detail-actions" *ngIf="reward.detailButtonTitles?.length">
          <button mat-raised-button type="button" *ngFor="let title of reward.detailButtonTitles || []">
            {{ title }}
          </button>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<ng-template #noReward>
  <div class="empty-preview">No snack preview selected.</div>
</ng-template>
